import React from 'react'
import PropTypes from 'prop-types'
import CustomJsonLd from '../CustomJsonLd'
import {
  getContentfulJsonLdDomId,
  normalizeJsonLdSchemaItems,
} from 'src/common/getContentfulJsonLd'

/** Renders Contentful JSON-LD blocks at the bottom of the page body. */
export default function ContentfulJsonLdBlocks({ jsonLdSchemas = null }) {
  const blocks =
    normalizeJsonLdSchemaItems(
      Array.isArray(jsonLdSchemas) ? jsonLdSchemas : []
    ) ?? []

  if (!blocks.length) {
    return null
  }

  return (
    <div data-testid="json-ld-blocks" aria-hidden="true">
      {blocks.map((schema, index) => {
        const jsonLdId = getContentfulJsonLdDomId(schema.jsonld, index)

        return (
          <CustomJsonLd key={jsonLdId} id={jsonLdId} data={schema.jsonld} />
        )
      })}
    </div>
  )
}

ContentfulJsonLdBlocks.propTypes = {
  jsonLdSchemas: PropTypes.array,
}
